
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-request",
      function () {
        return require("private-next-pages/data-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-request"])
      });
    }
  